
{
  "familyId": "TAA-WOORD-SYNONIEM",
  "questions": [
    {
      "id": "TAA-WOORD-SYNONIEM-001",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "multiple_choice",
      "question": "Welk woord is een synoniem van 'blij'?",
      "context": null,
      "options": ["Vrolijk", "Verdrietig", "Boos", "Bang"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniemen",
            "content": "Een synoniem is een woord met (bijna) dezelfde betekenis. 'Blij' en 'vrolijk' betekenen allebei dat je een goed gevoel hebt.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_basic",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Een synoniem is een woord met dezelfde of bijna dezelfde betekenis. 'Blij' = een goed, gelukkig gevoel. 'Vrolijk' = een goed, opgewekt gevoel. Ze betekenen bijna hetzelfde → synoniem.",
        "distractorExplanations": {
          "0": "Correct! 'Vrolijk' is een synoniem van 'blij' — beide betekenen een goed gevoel.",
          "1": "'Verdrietig' is het tegenovergestelde (antoniem) van 'blij', niet een synoniem.",
          "2": "'Boos' is een ander gevoel (woede), niet hetzelfde als 'blij'.",
          "3": "'Bang' is een ander gevoel (angst), niet hetzelfde als 'blij'."
        }
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-002",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "matching",
      "question": "Koppel elk woord aan zijn synoniem.",
      "context": null,
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Groot", "Snel", "Mooi", "Slim"],
        "rightItems": ["Knap", "Vlug", "Fors", "Intelligent"],
        "correctMatches": {"0": 2, "1": 1, "2": 0, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniemen koppelen",
            "content": "Groot = fors (allebei 'van grote omvang'). Snel = vlug (allebei 'met hoge snelheid'). Mooi = knap (allebei 'aantrekkelijk'). Slim = intelligent (allebei 'verstandig').",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_matching",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Groot ↔ Fors (grote omvang). Snel ↔ Vlug (hoge snelheid). Mooi ↔ Knap (aantrekkelijk). Slim ↔ Intelligent (verstandig)."
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-003",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN synoniem van 'koud'?",
      "context": null,
      "options": ["Warm", "Fris", "IJzig", "Kil"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniem of niet?",
            "content": "Synoniemen hebben dezelfde betekenis. 'Fris', 'ijzig' en 'kil' betekenen allemaal iets van koude. 'Warm' is het tegenovergestelde (antoniem).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_vs_antonym",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: zoek het woord dat NIET dezelfde betekenis heeft. Fris = een beetje koud ✓. IJzig = heel erg koud ✓. Kil = onaangenaam koud ✓. Warm = het tegenovergestelde van koud ✗. 'Warm' is geen synoniem maar een antoniem.",
        "distractorExplanations": {
          "0": "Correct! 'Warm' is het tegenovergestelde (antoniem) van 'koud', geen synoniem.",
          "1": "'Fris' is wél een synoniem van 'koud' — het betekent een beetje koud.",
          "2": "'IJzig' is wél een synoniem van 'koud' — het betekent heel erg koud.",
          "3": "'Kil' is wél een synoniem van 'koud' — het betekent onaangenaam koud."
        }
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-004",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "multiple_choice",
      "question": "Lees: 'De reiziger was uitgeput na de lange tocht.' Welk woord is een synoniem van 'uitgeput'?",
      "context": null,
      "options": ["Doodmoe", "Energiek", "Opgewekt", "Sterk"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniem uit context",
            "content": "Na een lange tocht is de reiziger heel erg moe. 'Uitgeput' = alle energie kwijt. 'Doodmoe' betekent hetzelfde: extreem moe.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_context",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: gebruik de context om de betekenis te bepalen. Stap 1: Na een lange tocht → de reiziger is heel moe. Stap 2: 'Uitgeput' = alle energie kwijt. Stap 3: 'Doodmoe' = extreem moe → synoniem.",
        "distractorExplanations": {
          "0": "Correct! 'Doodmoe' is een synoniem van 'uitgeput' — beide betekenen extreem moe.",
          "1": "'Energiek' is het tegenovergestelde — vol energie, niet uitgeput.",
          "2": "'Opgewekt' betekent vrolijk en levendig — het tegenovergestelde van uitgeput.",
          "3": "'Sterk' gaat over kracht, niet over vermoeidheid."
        }
      }
    },
    {
      "id": "TAA-WOORD-SYNONIEM-005",
      "familyId": "TAA-WOORD-SYNONIEM",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordenschat",
      "subSkill": "woord_synoniem",
      "questionType": "fill_in",
      "question": "Schrijf een synoniem van 'rennen'.",
      "context": null,
      "options": ["hardlopen"],
      "correctAnswer": 0,
      "data": {
        "acceptableAnswers": ["hardlopen", "sprinten", "hollen", "draven", "spurten", "snellen"],
        "placeholder": "Typ een synoniem...",
        "caseSensitive": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Synoniemen bedenken",
            "content": "Denk aan woorden die hetzelfde betekenen als 'rennen': hardlopen, sprinten, hollen, draven. Al deze woorden betekenen 'snel bewegen op je benen'.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "synonym_fill_in",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Synoniemen van 'rennen': hardlopen, sprinten, hollen, draven, spurten, snellen. Al deze woorden betekenen 'snel bewegen op je benen'."
      }
    }
  ]
}
